import { useEffect, useRef } from 'react'

import { useQuoteData } from '@flows-ui/services/QuoteDataContext'
import { defaultPermanentDiscountTracking } from '@flows-ui/utils/tracking'
import { EVENTS } from '@flows/configs/analytics/constants'
import type { ProductKey } from '@flows/index'

export const useQuoteStepViewedTracking = (productKey: ProductKey) => {
  const {
    priceData,
    productGeneration,
    premiumInterval,
    permanentDiscount,
    couponInfo,
    flowName,
    flowSessionId,
    trackEvent,
  } = useQuoteData()

  const hasFiredRef = useRef(false)

  useEffect(() => {
    if (hasFiredRef.current || !priceData || !productGeneration) {
      return
    }
    const productConfiguration = priceData.product_configurations.find(
      (configuration) => configuration.product_key === productKey
    )
    if (!productConfiguration) {
      return
    }
    hasFiredRef.current = true
    trackEvent(EVENTS.QuoteStepViewed, {
      flow_name: flowName,
      flow_session_id: flowSessionId,
      product_id: productKey,
      price: productConfiguration.prices.find(
        (price) => price.premium_interval === premiumInterval
      ),
      price_configuration: productConfiguration.configuration_id,
      premiumInterval,
      coupon_code: couponInfo?.code,
      permanent_discount: permanentDiscount
        ? {
            shown: permanentDiscount.shown,
            amount: permanentDiscount.amount,
            token: permanentDiscount.token,
            revoked: permanentDiscount.revoked,
          }
        : defaultPermanentDiscountTracking,
    })
  }, [
    couponInfo?.code,
    flowName,
    flowSessionId,
    permanentDiscount,
    premiumInterval,
    priceData,
    productGeneration,
    productKey,
    trackEvent,
  ])
}
